
export {Progress};

import {ipx, pxi} from './utils.js';

Progress.PADDING_H         = 20;
Progress.PADDING_V         = 10;
Progress.BGCOLOR           = "#111111";
Progress.OPACITY           = 0.9;
Progress.BORDER_W          = 3;
Progress.BORDER_CLR        = "#999999";
Progress.BORDER_R          = 5;
Progress.TEXT_H            = 14;
Progress.TEXT_LINE_H       = 24;
Progress.TEXT_CLR          = "#CCCCCC";
Progress.PCT_CLR           = "#CCCCCC";
Progress.THERMO_H          = 20;
Progress.THERMO_BORDER_W   = 1;
Progress.THERMO_BORDER_CLR = "#333333";
Progress.THERMO_BGCOLOR    = "#000000";
Progress.MERC_BGCOLOR      = "#666666";

function Progress(x, y, w) {

	// ---------------------------
	// Container
	// ---------------------------

	var d                   = document.createElement('div');
	d.style.width           = ipx(w);
	d.style.height          = ipx((Progress.TEXT_LINE_H * 2) + Progress.THERMO_H + Progress.PADDING_V);
	d.style.position        = "absolute";
	//d.style.left            = ipx(x);  // no longer using x
	d.style.left            = ipx((window.innerWidth / 2) - (w/2));
	//d.style.top             = ipx(y);  // no longer using y
	d.style.top             = ipx(((window.innerHeight / 4)*3) - (pxi(d.style.height)/2));
	d.style.border          = ipx(Progress.BORDER_W) + " solid " + Progress.BORDER_CLR;
	d.style.borderRadius    = ipx(Progress.BORDER_R);
	d.style.background      = Progress.BGCOLOR;
	d.style.opacity         = Progress.OPACITY;
	d.style.display         = "none";
	d.style.visibility      = "hidden";

	d.text                  = document.createElement('div');
	d.text.style.position   = "absolute";
	d.text.style.left       = ipx(Progress.PADDING_H);
	d.text.style.top        = ipx(Progress.PADDING_V);
	d.text.style.width      = ipx(w - (2 * Progress.PADDING_H));
	d.text.style.height     = ipx(Progress.TEXT_LINE_H);
	d.text.style.font       = "normal " + ipx(Progress.TEXT_H) + " arial,helvetica";
	d.text.style.lineHeight = ipx(Progress.TEXT_LINE_H);
	d.text.style.color      = Progress.TEXT_CLR;
	d.text.style.overflow   = "hidden";

	d.pct                   = document.createElement('div');
	d.pct.style.position    = "absolute";
	d.pct.style.left        = ipx(Progress.PADDING_H);
	d.pct.style.top         = ipx(Progress.PADDING_V);
	d.pct.style.width       = ipx(w - (2 * Progress.PADDING_H));
	d.pct.style.height      = ipx(Progress.TEXT_LINE_H);
	d.pct.style.font        = "normal " + ipx(Progress.TEXT_H) + " arial,helvetica";
	d.pct.style.lineHeight  = ipx(Progress.TEXT_LINE_H);
	d.pct.style.color       = Progress.PCT_CLR;
	d.pct.style.overflow    = "hidden";
	d.pct.style.textAlign   = "right";

	d.thermo                = document.createElement('div');
	d.thermo.style.position = "absolute";
	d.thermo.style.left     = ipx(Progress.PADDING_H);
	d.thermo.style.top      = ipx(Progress.PADDING_V + Progress.TEXT_LINE_H);
	d.thermo.style.width    = ipx(w - (2 * Progress.PADDING_H));
	d.thermo.style.height   = ipx(Progress.THERMO_H - (2 * Progress.THERMO_BORDER_W));
	d.thermo.style.border   = ipx(Progress.THERMO_BORDER_W) + " solid " + Progress.THERMO_BORDER_CLR;
	d.thermo.style.background = Progress.THERMO_BGCOLOR;
	d.thermo.style.overflow = "hidden";

	d.merc                  = document.createElement('div');
	d.merc.style.position   = "absolute";
	d.merc.style.left       = ipx(0);
	d.merc.style.top        = ipx(0);
	d.merc.style.width      = ipx(0);
	d.merc.style.height     = ipx(Progress.THERMO_H - (2 * Progress.THERMO_BORDER_W));
	d.merc.style.background = Progress.MERC_BGCOLOR;

	d.max                   = 0;
	d.prog                  = 0;


	// ---------------------------
	// Inits
	// ---------------------------

	d.appendChild(d.text);
	d.appendChild(d.pct);
	d.appendChild(d.thermo);
	d.thermo.appendChild(d.merc);


	// ---------------------------
	// Functions
	// ---------------------------

	d.set_max      = f_set_max;
	d.set_progress = f_set_progress;
	d.increment    = f_increment;
	d.set_text     = f_set_text;
	d.reset        = f_reset;
	d.show         = f_show;
	d.hide         = f_hide;


	// ---------------------------
	// Methods
	// ---------------------------

	function f_set_max(m) {
		d.max = m;
	}

	function f_set_progress(p) {
		d.prog = Math.min(p, d.max);
		d.pct.innerHTML    = Math.floor(100 * d.prog / d.max) + "%";
		d.merc.style.width = ipx((d.prog / d.max) * (w - (2 * Progress.PADDING_H)));

		if (d.prog >= d.max) {
			window.setTimeout(function() { f_hide(); }, 2000);
		}
	}

	function f_increment(i) {
		d.prog += i;
		f_set_progress(d.prog);
	}

	function f_set_text(t) {
		d.text.innerHTML = t;
	}

	function f_reset() {
		d.prog = 0;
		d.max  = 0;
		d.pct.innerHTML    = "0%";
		d.merc.style.width = ipx(0);
	}

	function f_show(tf) {
		if ((tf == undefined) || (tf == true)) {
			d.style.display    = "block";
			d.style.visibility = "visible";
		} else {
			d.style.display    = "none";
			d.style.visibility = "hidden";
		}
	}

	function f_hide() {
		f_show(false);
	}


	// ---------------------------
	// Return
	// ---------------------------

	return d;
}
